<script setup>
defineProps({
  triggerEvent: {
    type: String,
    default: undefined,
  },
});

const currencyStore = useCurrencyStore();

function setCurrencyId(currencyId, close) {
  currencyStore.setCurrencyId(currencyId);

  close();
}
</script>

<template>
  <UiDropdown
    class="bundles-currency-select"
    position="bottom"
    :trigger-event="triggerEvent"
    use-v-if
  >
    <template #trigger>
      <div class="bundles-currency-select__trigger">
        <slot />

        <div class="bundles-currency-select__selected">
          <span
            class="bundles-currency-select__font bundles-currency-select__font--trigger"
          >
            {{ currencyStore.currencyInfo.name }}
          </span>
        </div>
      </div>
    </template>

    <template #content="{ close }">
      <ul class="bundles-currency-select__list">
        <li
          v-for="currency in currencyStore.currencies"
          :key="currency.id"
          class="bundles-currency-select__item"
          :class="{
            'bundles-currency-select__item--selected':
              currencyStore.currencyId === currency.id,
          }"
          @click="setCurrencyId(currency.id, close)"
        >
          <span
            class="bundles-currency-select__font bundles-currency-select__font--list"
          >
            {{ currency.name }}
          </span>
        </li>
      </ul>
    </template>
  </UiDropdown>
</template>
